import { createSlice } from "@reduxjs/toolkit";
import {  fetchAIChatReportTableColumnNames, fetchAIChatReport } from "../thunks";
import { fetchAIChat, fetchAIClientUsers, updateChatFeedbackStatus, deleteAIChatReport, fetchReportedTableColumnNames, fetchUserReportedIssues, fetchReportedIssuesClientUsers, deleteReportedIssues, updateReportedIssueStatus, fetchUserReportedChats } from "./thunk";

const initialState = {
  chatSession: [],
  humanCategories: [],
  clientUsers: [],
  tableColumnNames: [],
  chats: [],
  loading: false,
  headerLoading: false,
  updateChatFeedbackStatusLoading: false,
  clientUsersloading: false,
  categoryloading: false,
  chatloading: false,
  error: null,
};

const ReportedLegalIssuesSlice = createSlice({
  name: "reportedLegalIssues",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

    // Fetch Chat Report Table Column Names
    .addCase(fetchReportedTableColumnNames.pending, (state) => {
        state.headerLoading = true;
        state.error = null;
    })
    .addCase(fetchReportedTableColumnNames.fulfilled, (state, action) => {
        state.headerLoading = false;
        state.tableColumnNames = action.payload;
    })
    .addCase(fetchReportedTableColumnNames.rejected, (state, action) => {
        state.headerLoading = false;
        state.error = action.payload;
    })


    .addCase(fetchUserReportedIssues.pending, (state) => {
        state.loading = true;
        state.error = null;
    })
    .addCase(fetchUserReportedIssues.fulfilled, (state, action) => {
        state.loading = false;
        state.chatSession = action.payload;
    })
    .addCase(fetchUserReportedIssues.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })

    .addCase(fetchUserReportedChats.pending, (state) => {
        state.chatloading = true;
        state.error = null;
    })
    .addCase(fetchUserReportedChats.fulfilled, (state, action) => {
        state.chatloading = false;
        state.chats = action.payload;
    })
    .addCase(fetchUserReportedChats.rejected, (state, action) => {
        state.chatloading = false;
        state.error = action.payload;
    })

    .addCase(fetchReportedIssuesClientUsers.pending, (state) => {
        state.clientUsersloading = true;
        state.error = null;
    })
    .addCase(fetchReportedIssuesClientUsers.fulfilled, (state, action) => {
        state.clientUsersloading = false;
        state.clientUsers = action.payload;
    })
    .addCase(fetchReportedIssuesClientUsers.rejected, (state, action) => {
        state.clientUsersloading = false;
        state.error = action.payload;
    })

    .addCase(updateReportedIssueStatus.pending, (state) => {
        state.updateChatFeedbackStatusLoading = true;
        state.error = null;
    })
    .addCase(updateReportedIssueStatus.fulfilled, (state, action) => {
        state.updateChatFeedbackStatusLoading = false;
        const { ID, Status, Comment } = action.payload;
        state.chatSession = state.chatSession.map((item) => {
            console.log(state.chatSession, item.ID, ID, Status, Comment);
            return item.ID == ID
                ? { ...item, Status, Comment }
                : item;
        });
    })
    .addCase(updateReportedIssueStatus.rejected, (state, action) => {
        state.updateChatFeedbackStatusLoading = false;
        state.error = action.payload;
    })

    .addCase(deleteReportedIssues.pending, (state) => {
        state.error = null;
    })
    .addCase(deleteReportedIssues.fulfilled, (state, action) => {
        const ids = action.payload.map((item) => item.ID);
        state.chatSession = state.chatSession.filter((item) => !ids.includes(item.ID));
    })
    .addCase(deleteReportedIssues.rejected, (state, action) => {
        state.error = action.payload;
    })
  },
});

export default ReportedLegalIssuesSlice.reducer;
